import React from 'react';

import { FormikSecretField } from 'components';
import { FormFieldProps } from 'types';

import { useTFeature } from '../fields.utils';

export const Field: React.FC<FormFieldProps> = ({
  name,
  required = false,
  disabled = false,
}) => {
  const { t } = useTFeature();

  return (
    <FormikSecretField
      name={name}
      label={t('fields.qr_manager_api_key.label')}
      fullWidth
      required={required}
      disabled={disabled}
    />
  );
};
